import { render, staticRenderFns } from "./MotionBox.vue?vue&type=template&id=406c66b2&scoped=true"
import script from "./MotionBox.vue?vue&type=script&lang=js"
export * from "./MotionBox.vue?vue&type=script&lang=js"
import style0 from "./MotionBox.vue?vue&type=style&index=0&id=406c66b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406c66b2",
  null
  
)

export default component.exports